import { useParams } from 'react-router-dom'

import { Box, Button, makeStyles } from '@material-ui/core'
import CropIcon from '@material-ui/icons/Crop'

import firebase from 'firebase/app'

import { ImageCropper } from 'UI/Components'
import { ImageWithLoad } from './ImageWithLoad'

import { useAuth, useBoolean } from 'hooks'
import { firebaseConfig } from 'env'
import { uuid } from 'modules'
import { QuickGuiddeType } from 'app/types'

const useStyles = makeStyles({
    cropButton: {
        position: 'absolute',
        bottom: 16,
        right: 16,
        borderRadius: 4,
        backgroundColor: 'white'
    }
})

type Props = {
    isEditMode: boolean
    step: QuickGuiddeType
    onUpdate: (_url: string) => void
}

export const StepScreenshot = ({ isEditMode, step, onUpdate }: Props) => {
    const classes = useStyles()

    const {
        docScreenshot,
        previewScreenshot,
        windowDimensions: { innerWidth, innerHeight }
    } = step

    const showCropper = useBoolean()

    const { playbookId } = useParams<{ playbookId: string }>()
    const { uid } = useAuth()

    const imageUrl = `${docScreenshot || previewScreenshot}&time=${new Date()}`

    return (
        <>
            <Box position="relative">
                <ImageWithLoad imageUrl={imageUrl} borderRadius={12} />
                {isEditMode && (
                    <Box className={classes.cropButton}>
                        <Button
                            variant="text"
                            color="default"
                            onClick={showCropper.setTrue}
                            style={{ minWidth: 30 }}
                            startIcon={<CropIcon fontSize="small" />}
                        >
                            Crop
                        </Button>
                    </Box>
                )}
            </Box>

            {showCropper.isTrue && (
                <ImageCropper
                    initialPreviewURL={imageUrl}
                    aspectRatio={innerWidth / innerHeight}
                    labelComponent={null}
                    title="Drag & Zoom"
                    storageRef={firebase
                        .app()
                        .storage(`gs://${firebaseConfig.projectId}-temporary`)
                        .ref(`imageUploads/${uid}/${playbookId}/${step.id}_${uuid()}`)}
                    onDone={({ height, width, url }) => {
                        onUpdate(url)
                        console.error({ height, width, url })
                        showCropper.setFalse()
                    }}
                    tooltipTitle="Revert to Default"
                    onClose={showCropper.setFalse}
                />
            )}
        </>
    )
}
